export default __webpack_public_path__ + "src/assets/back.673c1a58896008a4f597908cccece602.svg";